<template>
  <div>
    <van-cell class="ry-form__date-input" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{currentContent}}
        </div>
        <van-field
          v-if="!isRead"
          :readonly="isReadOnly"
          @change="controlChange"
          :value="currentContent"
          @focus="inputFocus"
          @blur="inputBlur"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
        </van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__date-range-input-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div>
            {{currentContent}}
          </div>
        </template>
      </van-field>

      <van-field
        v-if="!isRead"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly"
        @change="controlChange"
        :value="currentContent"
        @focus="inputFocus"
        @blur="inputBlur"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请填写内容'"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #button>
          <van-icon
            v-if="currentRow[dataId] && currentRow[dataId].length && !isReadOnly"
            name="close"
            class="close-btn"
            @click.stop="clearData">
          </van-icon>
        </template>
      </van-field>
    </div>

    <van-calendar
      v-model="show"
      type="range"
      :min-date="new Date('1870')"
      :max-date="new Date('2120')"
      :default-date="defaultDate"
      @confirm="onConfirm">
    </van-calendar>
  </div>

</template>

<script>
  import { current } from './mixin'
  import { formatDate } from '../../utils'
  import { DATE_TYPE__DAY, DATE_TYPE__SECTION } from '../../types'

  export default {
    mixins: [current],
    data () {
      return {
        show: false,
        isError: false,
        DATE_TYPE__DAY
      }
    },
    computed: {
      defaultDate () {
        const val = this.currentRow[this.dataId]
        const start = val[0] ? new Date(+val[0]) : new Date()
        const end = val[1] ? new Date(+val[1]) : new Date(Date.now() + 24 * 60 * 60 * 1000)
        return [start, end]
      },
      errorMessage () {
        return this.isError ? this.current.requiredShowText : ''
      },
      currentContent () {
        const val = this.currentRow[this.dataId]
        const start = val[0] ? this.formatDate(val[0]) : ''
        const end = val[1] ? this.formatDate(val[1]) : ''
        return start || end ? `${start} - ${end}` : ''
      },
      currentDateType () {
        if (this.current.dateType === DATE_TYPE__SECTION) {
          return 'datetime'
        } else {
          return 'date'
        }
      }
    },
    methods: {
      formatDate (val) {
        let format = 'yyyy-MM-dd'
        if (this.current.dateType === DATE_TYPE__SECTION) {
          format = 'yyyy-MM-dd HH:mm'
        }
        return formatDate(val)(format)
      },
      onConfirm (dateList) {
        this.show = false
        this.currentRow[this.dataId] = dateList.map(item => +item)
      },
      inputFocus (event) {
        if (this.isReadOnly) return
        this.show = true
        event.target.blur()
      },
      inputBlur () {
        this.isError = this.current.checkMissValue
          && (!this.currentRow[this.dataId][0] || !this.currentRow[this.dataId][1])
      },
      clearData() {
        this.currentRow[this.dataId].splice(0, this.currentRow[this.dataId].length)
        this.controlChange()
      }
    }
  }
</script>
